import styled from "@emotion/styled";
import Select from "react-select";
import {
    boxSizes,
    colors,
    colorVariables,
    fontSizes,
    gutterSizes,
    lineHeights,
} from "@gumtree/ui-library/src/base/theme";
import { Icon, Button } from "@gumtree/ui-library";

const RADIUS_BLOCK_WIDTH = 35;
const INPUT_HEIGHT = "38px";

export const StyledLocationField = styled.div`
    position: relative;
    margin-bottom: ${gutterSizes.medium10};

    .location-input-icon {
        position: absolute;
        left: ${gutterSizes.medium};
        top: ${gutterSizes.medium};
        color: ${colors.bark80};
        font-size: ${fontSizes.large};
        z-index: 11;
    }

    .form-element {
        outline: 2px solid transparent;
        border-radius: 4px;

        &:focus-within {
            outline: 2px solid ${colors.gtallBlue};
        }

        .input-clear {
            color: ${colors.bark80};
            height: ${INPUT_HEIGHT};
            box-sizing: content-box;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: ${INPUT_HEIGHT};
        }
    }

    & input {
        border-radius: 4px;
        font-size: ${fontSizes.base};
        height: ${INPUT_HEIGHT};
        padding: 0 38px;
        border-color: ${colors.bark40};
    }
`;

export const StyledSearchResults = styled.div`
    margin-bottom: ${gutterSizes.medium};
`;

export const StyledLocationItem = styled.div`
    display: flex;
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    padding: ${gutterSizes.medium10};

    .location-search-icon {
        margin-right: ${gutterSizes.medium};
        color: ${colors.bark80};
        font-size: ${fontSizes.large};
    }

    &:hover {
        cursor: pointer;
        background-color: ${colors.surface};
    }
`;

export const StyledRadiusBlock = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const StyledUpdateButton = styled(Button)`
    height: 38px;
`;

export const StyledSelect = styled(Select)`
    width: ${100 - RADIUS_BLOCK_WIDTH}%;
    margin-right: ${gutterSizes.base};

    &:focus-within {
        outline: 2px solid ${colors.gtallBlue};
        border-radius: ${boxSizes.borderRadius4};
    }

    .react-select__indicator-separator {
        display: none;
    }

    .react-select__control {
        border-color: ${colors.bark40};
        box-shadow: none;

        &:hover {
            border-color: ${colorVariables.textSecondary};
        }
    }

    .react-select__menu {
        width: 200px;
        border-radius: ${gutterSizes.large};
    }

    .react-select__menu-list {
        background-color: #f5f4f5;
        padding: 0;
        border-radius: ${gutterSizes.large};
    }

    .react-select__option {
        padding-left: ${gutterSizes.xlarge};
        border-bottom: 1px solid ${colorVariables.borderLight};
    }

    .react-select__option--is-focused {
        cursor: pointer;
        background-color: ${colors.bark10};
    }

    .react-select__option--is-selected {
        background-color: transparent;
        color: inherit;
    }

    .react-select__indicator {
        color: ${colors.bark80};
    }
`;

export const StyledOptionContainer = styled.div`
    position: relative;
`;

export const StyledIcon = styled(Icon)`
    position: absolute;
    top: ${gutterSizes.medium10};
    left: ${gutterSizes.small};
    transform: scale(0.7);
`;
